import React from 'react';
import { Card, CardContent } from './card';
import { cn } from '../../lib/utils';

interface StatBoxProps {
  title: string;
  value: number;
  valueType?: 'integer' | 'cents' | 'currency';
  icon?: React.ReactNode;
  span?: number;
  className?: string;
}

export function StatBox({ 
  title, 
  value, 
  valueType = 'integer', 
  icon, 
  span = 1,
  className 
}: StatBoxProps) {
  const formatValue = (val: number, type: string) => {
    switch (type) {
      case 'cents':
        return new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        }).format(val / 100);
      case 'currency':
        return new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        }).format(val);
      case 'integer':
      default:
        return new Intl.NumberFormat('pt-BR').format(val);
    }
  };

  return (
    <Card className={cn(
      "min-h-[140px]",
      span > 1 && `col-span-${span}`,
      className
    )}>
      <CardContent className="p-6 flex flex-col justify-between h-full">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <p className="text-sm font-medium text-muted-foreground mb-2">
              {title}
            </p>
            <p className="text-2xl font-bold text-foreground">
              {formatValue(value, valueType)}
            </p>
          </div>
          {icon && (
            <div className="ml-4 flex-shrink-0">
              {icon}
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}